<mat-table [dataSource]="summaries">
  <ng-container matColumnDef="group">
    <mat-header-cell *matHeaderCellDef>group</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.beneficiaryGroupCode }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="round">
    <mat-header-cell *matHeaderCellDef>round</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.round }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="comment">
    <mat-header-cell *matHeaderCellDef>comment</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.comments }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="amount">
    <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.surveyCount }}</mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowClick(row)"></mat-row>
</mat-table>
